module.exports = __webpack_public_path__ + "static/img/7.c7b3def.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/sp/7.png
// module id = 7ny/
// module chunks = 0